import { BASE_SECURITY_URL } from '../config'
export async function getAuthToken(key, username = '', password = '') {
  const res = await fetch(
    `${BASE_SECURITY_URL}/login?username=${username}&password=${password}&logintype=connectone`,
  )
  const data = await res.json()
  return data
}
